<template>
  <div id="popup-wrap">
    <van-popup v-model="isSync" class="popup-wrap">
      <div class="popup-box">
        <div class="popup-header">
          <div class="popup-title">同步消息模版</div>
          <img src="../../../../../assets/img/h5/official/home_icon_cross.png" @click="handelCancel"/>
        </div>
        <div class="popup-content">
          <div class="explain">
            <div class="explain-title">说明：</div>
            <div class="explain-tip">
              <div><span class="font-11">1、公众号必须为“服务号”才能进行消息模板推送;</span></div>
              <div><span class="font-11">2、开通模板时，须选择“IT科技/互联网|电子商务”行业，如下图所示；</span></div>
              <div><span class="font-11">3、申请理由随意填写，并开通自定义菜单。若已经开通过消息模板，需确保行业一致，不一致可在腾讯公众号管理后台修改</span></div>
            </div>
          </div>
          <div class="step-wrap">
            <div class="step-box">
              <div class="step-div">
                <div class="step-title">步骤一</div>
                <div class="step-content">登录腾讯公众号后台，完成公众号模版消息开通</div>
              </div>
              <div class="step-img">
                <img src="../../../../../assets/img/official/steps.png"/>
              </div>
            </div>
            <div class="step-box">
              <div class="step-div">
                <div class="step-title">步骤二</div>
                <div class="step-content">点击开始同步按钮进行模板同步</div>
              </div>
              <div class="sync-btn" @click="sycn()">开始同步</div>
            </div>
          </div>
        </div>
      </div>
    </van-popup>
    <SyncTemplateInfo ref="info"></SyncTemplateInfo>
  </div>
</template>

<script>
  import { Modal } from 'view-design'
  import SyncTemplateInfo from '@/views/h5/official/authorization/modal/SyncTemplateInfo.vue'
  export default {
    name: "SyncTemplate",
    components: {
      Modal,
      SyncTemplateInfo
    },
    props: {},
    created() {},
    data: function () {
      return {
        isSync: false,
      }
    },
    computed:{
    },
    methods: {
      init: function () {
        this.isSync = true
      },
      sycn: function () {
        this.$refs.info.init()
      },
      handelCancel: function (){
        this.isSync = false
      }
    }
  }
</script>

<style lang="less" scoped>
.explain{
  line-height: 17px;
  .explain-title{
    font-family: Alibaba-PuHuiTi-M;
    font-size: 14px;
    color: #FF4F76;
  }
  .explain-tip{
    margin-top: 2px;
    font-family: Alibaba-PuHuiTi-R;
    color: #666666;
  }
}
.step-wrap{
  padding-top: 3px;
  margin-bottom: 5px;
  .step-box{
    background: #FAFAFA;
    margin-top: 10px;
    padding: 10px 10px 10px 15px;
    .step-div{
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      .step-title{
        background-image: linear-gradient(90deg, #FFBB47 6%, #FF8622 89%, #FF8622 89%);
        border-radius: 14px;
        font-size: 12px;
        color: #FFFFFF;
        width: 60px;
        text-align: center;
        padding: 4px 0;
        margin-bottom: 10px;
        margin-right: 8px;
      }
      .step-content{
        font-size: 12px;
        color: #222222;
        margin-bottom: 10px;
      }
    }
    .step-img{
      background: #FFFFFF;
      border: 1px solid #FF8622;
      border-radius: 2px;
      padding:12px 5px;
      margin-right: 5px;
      img{
        width: 120px;
      }
    }
    .sync-btn{
      border: 1px solid #FF4F76;
      border-radius: 12px;
      font-size: 12px;
      color: #FF4F76;
      width: 120px;
      padding: 4px 0;
      text-align: center;
      margin: 10px auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/h5/official/authorization/modal/SyncTemplate.vue